import type { JSX } from '@builder.io/qwik';
import { useContext } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import { cva } from 'class-variance-authority';
import {
  getCSSColorBorder,
  getCSSColorHoverBorder,
  getCSSColorHoverText,
  getCSSColorText,
} from '~/utilities/getCSS';
import { AppDataContext } from '~/contexts/AppDataContext';

const tagClasses = cva(
  'block p-2.5 border border-solid min-w-min w-max whitespace-nowrap font-group-tiny bg-white',
  {
    variants: {
      text: getCSSColorText(),
      textHover: getCSSColorHoverText(),
      border: getCSSColorBorder(),
      borderHover: getCSSColorHoverBorder(),
    },
  }
);

type TagType = {
  text: string;
  link: string;
};

export default component$<TagType>(({ text, link }): JSX.Element => {
  const {
    themeComponents: {
      tag: { tagActiveColor, tagHoverColor },
    },
  } = useContext(AppDataContext);

  return (
    <a
      class={tagClasses({
        text: tagActiveColor.value,
        textHover: tagHoverColor.value,
        border: tagActiveColor.value,
        borderHover: tagHoverColor.value,
      })}
      href={link}
      data-testtype='tag'
    >
      {text}
    </a>
  );
});
